// // アコーディオンの起動 // Activate the accordion
// jQuery(function ($) {
// 	if ($('.js-accordion .js-accordion-toggle').length > 0) {
// 		document.querySelectorAll(".js-accordion .js-accordion-toggle").forEach(toggle => {
//       try {
//         toggle.addEventListener('click', function(e) {
//           e.preventDefault();
//           e.stopPropagation();
//           const button = e.target.closest('.js-accordion-toggle');
//           const content = button.closest('.js-accordion').querySelector('.js-accordion-target');
//           if (!content) throw new Error('開閉するボックスがありません');
//           $(content).slideToggle(500);
//           $(button).toggleClass("is-open");
//         }, false)
//       } catch(err) {
//         console.error(err);
//       }

//     });
// 	}
// });


// アコーディオンの起動 // Activate the accordion
jQuery(function ($) {
  if ($('.js-accordion-toggle').length > 0) {
    $(".js-accordion-toggle").click(function () {
      $(this).next(".js-accordion-target").slideToggle();
      $(this).toggleClass("is-open");
    });
  }
});

